import { render, staticRenderFns } from "./CategoriesManagement.vue?vue&type=template&id=4f36542a&"
import script from "./CategoriesManagement.vue?vue&type=script&lang=js&"
export * from "./CategoriesManagement.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports